/** Тексты окна: Лига и друзья. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.league.title": "League",
  "win.league.tab.group": "League",
  "win.league.tab.friends": "Friends",
  "win.league.tier.bronze": "Bronze league",
  "win.league.tier.silver": "Silver league",
  "win.league.tier.gold": "Gold league",
  "win.league.tier.platinum": "Platinum league",
  "win.league.tier.diamond": "Diamond league",
  "win.league.left": "Ends in {d} d",
  "win.league.you": "{name} (you)",
  "win.league.claim": "Claim",
  "win.league.result.up": "Last week: {place} of {size} in {tier}. You moved up!",
  "win.league.result.stay": "Last week: {place} of {size} in {tier}. You stayed.",
  "win.league.result.down": "Last week: {place} of {size} in {tier}. You moved down.",
  "win.league.rules": "Real players only. Season points count. Top rows move up, bottom rows move down on Monday.",
  "win.league.alone": "You're the first this week. Players join as they earn points.",
  "win.league.empty": "Clear a wave to join this week's group.",
  "win.league.guest": "Leagues and friends need a Telegram account: your progress stays with it.",
  "win.league.noFriends": "No friends here yet. Send your link: whoever opens it joins this list.",
  "win.league.invite": "Invite a friend",
  "win.league.inviteText": "Zombies are coming. Hold the base with me!",
  "win.league.friendReward": "A new player from your link clears wave {wave}: +{coins} coins for each of you.",
  "win.league.friendEarned": "Friend rewards: {n} of {cap}.",
  "win.league.friendCap": "Friend rewards: {cap} of {cap}. Friends still join your list, and they get their bonus.",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.league.title": "Лига",
  "win.league.tab.group": "Лига",
  "win.league.tab.friends": "Друзья",
  "win.league.tier.bronze": "Бронзовая лига",
  "win.league.tier.silver": "Серебряная лига",
  "win.league.tier.gold": "Золотая лига",
  "win.league.tier.platinum": "Платиновая лига",
  "win.league.tier.diamond": "Алмазная лига",
  "win.league.left": "Конец через {d} дн.",
  "win.league.you": "{name} (вы)",
  "win.league.claim": "Забрать",
  "win.league.result.up": "Прошлая неделя: {place} из {size}, {tier}. Вы поднялись!",
  "win.league.result.stay": "Прошлая неделя: {place} из {size}, {tier}. Вы остались.",
  "win.league.result.down": "Прошлая неделя: {place} из {size}, {tier}. Вы опустились.",
  "win.league.rules": "Только живые игроки. Считаются очки сезона. В понедельник верх поднимается, низ опускается.",
  "win.league.alone": "Вы первый на этой неделе. Игроки появятся, когда наберут очки.",
  "win.league.empty": "Пройдите волну, чтобы попасть в группу этой недели.",
  "win.league.guest": "Для лиги и друзей нужен аккаунт Telegram: прогресс останется при вас.",
  "win.league.noFriends": "Друзей пока нет. Отправьте ссылку: кто её откроет, появится здесь.",
  "win.league.invite": "Позвать друга",
  "win.league.inviteText": "Зомби идут. Держим базу вместе!",
  "win.league.friendReward": "Новичок по вашей ссылке проходит волну {wave}: по +{coins} монет каждому.",
  "win.league.friendEarned": "Наград за друзей: {n} из {cap}.",
  "win.league.friendCap": "Наград за друзей: {cap} из {cap}. Друзья всё равно попадут в список и получат свой бонус.",
};

const uk: Record<Key, string> = {
  "win.league.title": "Ліга",
  "win.league.tab.group": "Ліга",
  "win.league.tab.friends": "Друзі",
  "win.league.tier.bronze": "Бронзова ліга",
  "win.league.tier.silver": "Срібна ліга",
  "win.league.tier.gold": "Золота ліга",
  "win.league.tier.platinum": "Платинова ліга",
  "win.league.tier.diamond": "Діамантова ліга",
  "win.league.left": "Кінець за {d} дн.",
  "win.league.you": "{name} (ви)",
  "win.league.claim": "Забрати",
  "win.league.result.up": "Минулий тиждень: {place} із {size}, {tier}. Ви піднялися!",
  "win.league.result.stay": "Минулий тиждень: {place} із {size}, {tier}. Ви залишилися.",
  "win.league.result.down": "Минулий тиждень: {place} із {size}, {tier}. Ви опустилися.",
  "win.league.rules": "Лише живі гравці. Рахуються очки сезону. У понеділок верх піднімається, низ опускається.",
  "win.league.alone": "Ви перший цього тижня. Гравці з'являться, коли наберуть очки.",
  "win.league.empty": "Пройдіть хвилю, щоб потрапити до групи цього тижня.",
  "win.league.guest": "Для ліги й друзів потрібен акаунт Telegram: прогрес залишиться з вами.",
  "win.league.noFriends": "Друзів поки немає. Надішліть посилання: хто його відкриє, з'явиться тут.",
  "win.league.invite": "Покликати друга",
  "win.league.inviteText": "Зомбі йдуть. Тримаймо базу разом!",
  "win.league.friendReward": "Новачок за вашим посиланням проходить хвилю {wave}: по +{coins} монет кожному.",
  "win.league.friendEarned": "Нагород за друзів: {n} із {cap}.",
  "win.league.friendCap":
    "Нагород за друзів: {cap} із {cap}. Друзі все одно потраплять у список і отримають свій бонус.",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
